import React, { useState, useEffect } from 'react';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import axios from 'axios';
import moment from 'moment-timezone';

import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import { Container } from '@material-ui/core';
import PrimaryButton from './lib/buttons/PrimaryButton';

import { Loading } from '../stories/Loading';

const StyledTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 14,
  },
}))(TableCell);

const StyledTableRow = withStyles((theme) => ({
  root: {
    '&:nth-of-type(odd)': {
      backgroundColor: theme.palette.action.hover,
    },
  },
}))(TableRow);

const SummaryTableCell = withStyles((theme) => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white,
  },
  body: {
    fontSize: 20,
    border: 2,
    borderColor: theme.palette.common.black,
    borderStyle: 'solid',
  },
}))(TableCell);

const useStyles = makeStyles((theme) => ({
  root: {
    width: 'auto',
    textAlign: 'start',
    margin: '8px',
    display: 'flex',
    flexDirection: 'column',
  },
  loadingContainer: {
    textAlign: 'start',
    height: 'calc(100VH - 120px)',
    justifyContent: 'center',
    alignItems: 'center',
    display: 'flex',
    width: '100VW',
  },
  componentTitle: {
    color: '#142966',
    textAlign: 'center',
    textTransform: 'uppercase',
    fontSize: '24px',
    marginBottom: '0px',
  },
  separatorLine: {
    height: '2px',
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
    [theme.breakpoints.up('sm')]: {
      width: 'calc(100% - 80px)',
    },
    background: '#004878',
    border: 'none',
  },
  table: {
    minWidth: 650,
  },
  button: {
    maxWidth: '320px',
    width: '100%',
    marginBottom: '24px',
    marginTop: '24px',
    alignSelf: 'center',
  },
}));

interface PositionListDetailsProps {}

const PositionListDetails = (props: PositionListDetailsProps) => {
  const classes = useStyles();
  const [loading, setLoading] = useState(false);
  const [positionList, setPositionList] = useState<[any]>();
  const [error, setError] = useState<string>();

  useEffect(() => {
    setLoading(true);
    (async () => {
      try {
        const response = await axios.get(
          `/api/getPositionList?fetchOnly=${true}`
        );
        setPositionList(response.data);
        response.data.forEach((item: any) => console.log(item));
        setError(undefined);
      } catch (error: any) {
        setError(error.message);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  const downloadPositionList = () => {
    setLoading(true);

    axios
      .get(`/api/getPositionList`, { responseType: 'blob' })
      .then((res) => res.data)
      .then((blob) => {
        var file = new Blob([blob], { type: 'application/pdf' });
        var url = URL.createObjectURL(file);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `PositionList.pdf`);
        document.body.appendChild(link);
        link.click();
        link?.parentNode?.removeChild(link);
      })
      .catch((err) => {
        alert('Error while downloading PositionList report!');
        console.log(err);
      })
      .finally(() => setLoading(false));
  };

  if (loading) {
    return (
      <div className={classes.loadingContainer}>
        <Loading />
      </div>
    );
  } else if (error) {
    return <div>{error}</div>;
  } else {
    return (
      <div className={classes.root}>
        <h2 className={classes.componentTitle}>Position List</h2>
        <hr className={classes.separatorLine} />
        <Container
          style={{
            marginTop: '24px',
            display: 'flex',
            flexDirection: 'column',
          }}
        >
          <PrimaryButton
            onClick={downloadPositionList}
            className={classes.button}
          >
            Download
          </PrimaryButton>
          <TableContainer component={Paper}>
            <Table className={classes.table} aria-label="simple table">
              <TableHead>
                <StyledTableRow>
                  <SummaryTableCell>R No</SummaryTableCell>
                  <SummaryTableCell>G Name</SummaryTableCell>
                  <SummaryTableCell>Check-in</SummaryTableCell>
                  <SummaryTableCell>Address</SummaryTableCell>
                  <SummaryTableCell>Notes</SummaryTableCell>
                  <SummaryTableCell>Coupons</SummaryTableCell>
                </StyledTableRow>
              </TableHead>
              <TableBody>
                {positionList &&
                  positionList.map((item) => {
                    const checkinDateStr = moment(item.checkin_date)
                      .tz('Asia/Kolkata')
                      .format('DD/MM');
                    const checkinTime = moment(
                      item.checkin_time,
                      'HH:mm'
                    ).format('hh:mm a');
                    return (
                      <StyledTableRow key={item.room_no}>
                        <StyledTableCell component="th" scope="row">
                          {item.room_no} <span>({item.room_type})</span>
                        </StyledTableCell>
                        <StyledTableCell>{item.first_name}</StyledTableCell>
                        <StyledTableCell>
                          {`${checkinDateStr} - ${checkinTime}`}
                        </StyledTableCell>
                        <StyledTableCell>{item.address}</StyledTableCell>
                        <StyledTableCell>{item.notes}</StyledTableCell>
                        <StyledTableCell>{`${
                          item.reference === 'direct'
                            ? `2 + ${item.extraCoupon}`
                            : item.ref_booking_id === '-SO-'
                            ? `1 + ${item.extraCoupon}`
                            : `? + ${item.extraCoupon}`
                        }`}</StyledTableCell>
                      </StyledTableRow>
                    );
                  })}
              </TableBody>
            </Table>
          </TableContainer>
        </Container>
      </div>
    );
  }
};

export default PositionListDetails;
